import { UserAvatar } from 'src/components';
import { Box } from '@mui/material';

export default function UserMarker({ u, isCurrentUser }) {
  const borderColor = isCurrentUser ? '#1976d2' : '#fff'; 
  const triangleColor = borderColor;

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* Avatar wrapper (circle) */}
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          boxShadow: '0 0 6px rgba(0,0,0,0.3)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <UserAvatar
          user={u}
          size={40}
          isMobile={false}
          sx={{
            color: 'white',
            fontSize: '1rem',
            border: `2px solid ${borderColor}`,
          }}
          showPrivacyBadge={true}
          badgeColor={borderColor}
        />
      </Box>

      {/* Triangle pointer */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '-3px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: `5px solid ${triangleColor}`,
          zIndex: 1
        }}
      />

      {/* Small circle underneath for current user */}
      {isCurrentUser && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '-14px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: borderColor,
          }}
        />
      )}

    </Box>
  );
}
